import CustomerSearch from "@@/core/components/shared/CustomerSearch/CustomerSearch";

import { BFormGroup, BTable } from "bootstrap-vue";

export default {
  name: "pointsEarned",
  components: {
    CustomerSearch,
    BTable,
    BFormGroup,
  },

  data() {
    return {
      selectedCustomer: "",
      disabled: false,
      url: "admin/customers_club/get_club_score_list",
      items: [],
      fields: [
        {
          label: "ردیف",
          key: "index",
        },
        {
          label: "امتیاز",
          key: "score_value",
        },
        {
          label: "بن",
          key: "bon_value",
        },
        {
          label: "عنوان",
          key: "cause_title",
        },
        {
          label: "محصول",
          key: "product",
        },
        {
          label: "تاریخ",
          key: "date",
        },
      ],
    };
  },
  watch: {
    "$route.query": function(newValue) {
      this.loadUserPointsList();
    },
  },

  methods: {
    async loadUserPointsList() {
      this.disabled = true;
      let page = this.$route.query.page || 1;
      await this.$axios
        .post(
          `${this.url}?customer_id=${
            this.selectedCustomer ? this.selectedCustomer.id : ""
          }&page=${page}`
        )
        .then((res) => {
          this.items = res.data.data.scores;
          this.$root.notify(res.data.message, "success");
        })
        .catch((err) => {
          this.$root.notify(err);
        })
        .finally(() => {
          this.disabled = false;
        });
    },
    changePage(page) {
      if (this.disabled) {
        return;
      }
      this.$router.replace({
        path: this.$route.path,
        query: { ...this.$route.query, page: page },
      });
    },
  },
};
